import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

/**
 * SectionHeader
 * Standardized header for form sections.
 * 
 * Props:
 * - title: Section title
 * - icon: Material UI Icon component (optional)
 * - iconColor: Color for the icon (default: primary blue)
 * - iconBg: Background color for the icon box (default: light blue)
 */
const SectionHeader = ({ title, icon, iconColor = "#1976d2", iconBg = "#e3f2fd" }) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" mb={3}>
        {icon && (
          <div style={{ backgroundColor: iconBg, padding: "8px", borderRadius: "8px", marginRight: "12px" }}>
             {/* Clone icon to enforce style if needed, or just render it */}
             {React.cloneElement(icon, { style: { color: iconColor, fontSize: "24px", ...icon.props.style } })}
          </div>
        )}
        <Typography variant="h6" style={{ fontWeight: 700, color: "#1a202c" }}>
          {title}
        </Typography>
      </Box>
      <Divider sx={{ mb: 4, borderColor: "#e2e8f0" }} />
    </Box>
  );
};

export default SectionHeader;
